var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"2.99984","x2":"2.99984","y2":"6","stroke":"#F5F2F2","strokeWidth":"0.666667","key":0}),React.createElement("line",{"y1":"2.99998","x2":"6","y2":"2.99998","stroke":"#F5F2F2","strokeWidth":"0.666667","key":1})]);
}

Plus.defaultProps = {"width":"6","height":"6","viewBox":"0 0 6 6","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
